import * as Yup from "yup";
import { Formik } from "formik";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaStickyNote, FaUser, FaClock } from "react-icons/fa";
import Task from "../Sections/Task";
import InteractionRecord from "../Sections/InteractionRecord";
import Service from "../Sections/Service";
import Purchase from "../Sections/Purchase";
import Quotation from "../Sections/Quotation";
import Status from "../Sections/Status";
import { path_url } from "../../Config/config";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import UserFooter from "../UserFooter";
import "../../Style/NewVendor.css";
const customerSchema = Yup.object().shape({
  product: Yup.string().required("Required"),
  preferences: Yup.string().required("Required"),
  status: Yup.string().required("Required"),
  notes: Yup.string(),
  direction: Yup.string().required("Required"),
});

const VendorDetailsTables = ({
  Details,
  refetchDetails,
  onOpenTaskModal,
  onOpenInteractionModal,
}) => {
  const navigate = useNavigate();
  const [vendorId, setVendorId] = useState("");
  useEffect(() => {
    // Ensure Details is not null and contains the vendor object
    if (Details && Details.vendor && Details.vendor.id) {
      setVendorId(Details.vendor.id); // Update the vendorId state
    }
    setExtraNotes([]);
  }, [Details]);
  const options = [
    { value: "Inbound", label: "Inbound" },
    { value: "Outbound", label: "Outbound" },
  ];

  const options1 = [
    { value: "Emergency", label: "Emergency" },
    { value: "High", label: "High" },
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "Normal", label: "Normal" },
    { value: "Deferred", label: "Deferred" },
    { value: "Critical", label: "Critical" },
  ];

  const options2 = [
    { value: "Close", label: "Close" },
    { value: "Open", label: "Open" },
  ];
  const options3 = [
    { value: "Inbound", label: "Inbound" },
  ];

  // ── Notes state ──────────────────────────────────────────────
  const [notesOpen, setNotesOpen] = useState(false);
  const [extraNotes, setExtraNotes] = useState([]);
  const [newNoteText, setNewNoteText] = useState("");
  const [noteSubmitting, setNoteSubmitting] = useState(false);

  // Derive persisted notes from backend data
  const backendNotes = (
    Details?.eventList?.notesList ||
    (Details?.eventList?.interactionRecordList || []).filter(
      (r) => r.notes || r.remarks || r.description || r.enquiry
    )
  ).map((r) => {
    let author = r.createdBy || r.author || "System";
    if (author === localStorage.getItem("userId")) {
      author = localStorage.getItem("name") || "You";
    }
    return {
      id: r.id || r.noteId,
      author,
      content: r.notes || r.content || r.remarks || r.description || r.enquiry || "",
      createdDate: r.createdAt
        ? new Date(r.createdAt).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
        : r.createdDate || "",
      updatedDate: r.updatedAt
        ? new Date(r.updatedAt).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
        : r.updatedDate || null,
    };
  });

  const notesList = [...extraNotes, ...backendNotes];

  const handleAddNote = async () => {
    if (!newNoteText.trim()) return;
    setNoteSubmitting(true);
    const token = localStorage.getItem("accessToken");
    const now = new Date();
    const formatted = now.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    const targetVendorId = Details?.vendor?.id || vendorId || "";
    const adminId = localStorage.getItem("adminId");
    const payload = {
      enquiry: newNoteText.trim(),
      ...(targetVendorId ? { vendorid: targetVendorId } : {}),
      useradminid: adminId,
      usercid: adminId,
      direction: "Inbound",
      status: "Close",
      priority: "Normal",
      product: "CRM",
    };
    try {
      const response = await axios.post(`${path_url}/interactionrecord`, payload, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      });
      if (response.data.statusCodeValue === 200 || response.status === 200 || response.status === 201) {
        toast.success("Note added successfully");
        setExtraNotes((prev) => [{ id: Date.now(), author: "You", content: newNoteText.trim(), createdDate: formatted, updatedDate: null }, ...prev]);
        setNewNoteText("");
        if (typeof refetchDetails === "function") refetchDetails();
      } else {
        setExtraNotes((prev) => [{ id: Date.now(), author: "You", content: newNoteText.trim(), createdDate: formatted, updatedDate: null }, ...prev]);
        setNewNoteText("");
        toast.warning("Note saved locally. Backend sync pending.");
      }
    } catch {
      setExtraNotes((prev) => [{ id: Date.now(), author: "You", content: newNoteText.trim(), createdDate: formatted, updatedDate: null }, ...prev]);
      setNewNoteText("");
      toast.warning("Note saved locally. Check your connection.");
    } finally {
      setNoteSubmitting(false);
    }
  };
  // ─────────────────────────────────────────────────────────────


  if (!Details) {
    return <div>Loading...</div>; // You can replace with a spinner or any loading indicator
  }

  return (
    <>
      <div>
        <Formik
          enableReinitialize={true}
          initialValues={{
            preferences: "Emergency",
            product: "CRM",
            status: "Close",
            direction: "Outbound",
            notes: "",
            vendorid: vendorId || Details?.vendor?.id || "",
          }}
          validationSchema={customerSchema}
          onSubmit={async (values) => {
            try {
              const token = localStorage.getItem("accessToken");
              const adminId = localStorage.getItem("adminId");
              const targetVendorId = vendorId || Details?.vendor?.id || "";
              const payload = {
                ...values,
                priority: values.preferences || values.priority || "Emergency",
                enquiry: values.notes || values.enquiry || "",
                direction: values.direction || "Outbound",
                status: values.status || "Close",
                product: values.product || "CRM",
                useradminid: adminId,
                usercid: adminId,
                ...(targetVendorId ? { vendorid: targetVendorId } : {}),
              };
              const response = await axios.post(`${path_url}/interactionrecord`, payload, {
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
              });
              if (response.data.statusCodeValue === 200 || response.status === 200 || response.status === 201) {
                toast.success("Interaction record submitted successfully");
                if (typeof refetchDetails === "function") refetchDetails();
              } else {
                toast.error(response.data.body || "Failed to save record");
              }
            } catch (errors) {
              console.error("Error saving interaction record:", errors);
              toast.error("Failed to save interaction record");
            }
          }}
        >
          {(formik) => (
            <form action="" onSubmit={formik.handleSubmit}>
              <fieldset
                style={{
                  paddingLeft: "5px",
                  width: "98%",
                  marginBottom: "5rem",
                }}
              >
                <div className=" mt-3">
                  <div className="row">
                    {/* ── Interaction Record Panel ── */}
                    <div className="col-lg-6 mb-3">
                      <div className="ir-notes-panel">
                        <div className="ir-notes-panel-title">
                          📋 Interaction Record
                        </div>

                        <div className="ir-field">
                          <label className="form-label">Direction</label>
                          <select
                            className="form-select form-select-sm"
                            name="direction"
                            id="direction"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.direction}
                          >
                            <option value="Outbound">Outbound</option>
                            {options3.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                          </select>
                        </div>

                        <div className="ir-grid-2">
                          <div>
                            <label className="form-label">Status</label>
                            <select
                              className="form-select form-select-sm"
                              name="status"
                              id="status"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.status}
                            >
                              <option value="Close">Close</option>
                              {options2.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                            </select>
                          </div>
                          <div>
                            <label className="form-label">Priority</label>
                            <select
                              className="form-select form-select-sm"
                              name="preferences"
                              id="priority"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.preferences}
                            >
                              <option value="Emergency">Emergency</option>
                              {options1.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                            </select>
                          </div>
                        </div>

                        <div className="ir-field">
                          <label className="form-label">Product</label>
                          <select
                            className="form-select form-select-sm"
                            name="product"
                            id="product"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.product}
                          >
                            <option value="CRM">CRM</option>
                            {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                          </select>
                        </div>

                        <div className="ir-field" style={{ flex: 1 }}>
                          <label className="form-label">Notes</label>
                          <textarea
                            className="form-control form-control-sm"
                            id="notes"
                            name="notes"
                            rows={3}
                            placeholder="Enter interaction notes..."
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.notes}
                            style={{ resize: "none" }}
                          />
                        </div>

                        <div className="text-end mt-2">
                          <button type="submit" className="btn btn-sm btn-info text-white px-4">
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* ── Notes Panel ── */}
                    <div className="col-lg-6 mb-3">
                      <div className="ir-notes-panel">
                        <div className="notes-section-header">
                          <FaStickyNote style={{ color: "#0dcaf0" }} />
                          Notes
                        </div>

                        <div className="notes-list">
                          {notesList.length === 0 ? (
                            <p className="notes-empty">No notes yet. Write below to add your first note.</p>
                          ) : (
                            notesList.map((note) => (
                              <div key={note.id} className="note-card">
                                <div className="note-card-header">
                                  <span className="note-card-author">
                                    <FaUser className="me-1" style={{ fontSize: "0.72rem" }} />
                                    {note.author}
                                  </span>
                                  <span className="note-card-date">
                                    <FaClock className="me-1" style={{ fontSize: "0.68rem" }} />
                                    {note.createdDate}
                                  </span>
                                </div>
                                <div className="note-card-body">
                                  <div className="note-card-content">{note.content}</div>
                                  {note.updatedDate && (
                                    <span className="note-updated"> (edited {note.updatedDate})</span>
                                  )}
                                </div>
                              </div>
                            ))
                          )}
                        </div>

                        <div className="note-composer mt-3">
                          <textarea
                            rows={2}
                            className="form-control note-textarea"
                            placeholder="Write a note about this vendor… (Ctrl+Enter to save)"
                            value={newNoteText}
                            onChange={(e) => setNewNoteText(e.target.value)}
                            disabled={noteSubmitting}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) handleAddNote();
                            }}
                          />
                          <div className="note-composer-actions">
                            <button
                              type="button"
                              className="note-save-btn"
                              onClick={handleAddNote}
                              disabled={noteSubmitting || !newNoteText.trim()}
                            >
                              {noteSubmitting ? "Saving…" : "Save Note"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 d-flex justify-content-center" id="vendor-tasks-section">
                    <div className="bg-white col-12 mt-3">
                      <div className="d-flex ">
                        <div className="bg-warning col-12 m-1 mt-3 rounded shadow-sm elevation-2 pt-1"></div>
                      </div>
                      <div
                        style={{
                          paddingBottom: 2,
                          paddingTop: 10,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <label className="ml-6 m-0" style={{ fontWeight: "700" }}>
                          Task
                        </label>
                        <button
                          type="button"
                          onClick={() => {
                            if (onOpenTaskModal) {
                              onOpenTaskModal();
                            } else {
                              navigate("/create-task", {
                                state: { vendorId: Details?.vendor?.id, vendor: Details?.vendor },
                              });
                            }
                          }}
                          className="btn btn-sm border btn-info "
                        >
                          Create Task
                        </button>
                      </div>
                      <div className="d-flex ">
                        <div className="col-12 ">
                          <Task tableData={Details?.eventList?.taskList} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 d-flex justify-content-center" id="vendor-interaction-section">
                    <div className="bg-white col-12 mt-3">
                      <div className="d-flex justify-content-right">
                        <div className="bg-info col-12 m-1 mt-3 rounded shadow-sm elevation-2 pt-1"></div>
                      </div>
                      <div
                        style={{
                          paddingBottom: 2,
                          paddingTop: 10,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <label className="ml-6 pt-2 m-0" style={{ fontWeight: "700" }}>
                          Interaction Record
                        </label>
                        <button
                          type="button"
                          onClick={() => {
                            if (typeof onOpenInteractionModal === "function") {
                              onOpenInteractionModal();
                            } else {
                              const el = document.getElementById("contact-section");
                              if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                              const notesField = document.getElementById("notes");
                              if (notesField) notesField.focus();
                            }
                          }}
                          className="btn btn-sm border btn-info "
                        >
                          Create Interaction Record
                        </button>
                      </div>
                      <div className="d-flex ">
                        <div className="col-12 ">
                          <InteractionRecord
                            tableData={Details?.eventList?.interactionRecordList}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 d-flex justify-content-center" id="vendor-service-section">
                    <div className="bg-white col-12 mt-3">
                      <div className="d-flex justify-content-right">
                        <div className="bg-info col-12 m-1 mt-3 rounded shadow-sm elevation-2 pt-1"></div>
                      </div>
                      <div
                        style={{
                          paddingBottom: 2,
                          paddingTop: 10,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <label className="ml-6 pt-2 m-0" style={{ fontWeight: "700" }}>
                          Service Request
                        </label>
                        <button
                          type="button"
                          onClick={() => {
                            if (onOpenTaskModal) {
                              onOpenTaskModal();
                            } else {
                              navigate("/create-task");
                            }
                          }}
                          className="btn btn-sm border btn-info "
                        >
                          Create Service Request
                        </button>
                      </div>
                      <div className="d-flex ">
                        <div className="col-12 ">
                          <Service
                            tableData={Details?.eventList?.serviceRequestList}
                          />
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 d-flex justify-content-center" id="vendor-purchase-section">
                    <div className="bg-white col-12 mt-3">
                      <div className="d-flex justify-content-right">
                        <div className="bg-info col-12 m-1 mt-3 rounded shadow-sm elevation-2 pt-1"></div>
                      </div>

                      <div
                        style={{
                          paddingBottom: 2,
                          paddingTop: 10,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <label className="ml-6 pt-2 m-0" style={{ fontWeight: "700" }}>
                          Purchase Order
                        </label>
                        <button
                          type="button"
                          onClick={() => {
                            navigate("/create-purchase-order", {
                              state: { vendorId: Details?.vendor?.id, vendor: Details?.vendor },
                            });
                          }}
                          className="btn btn-sm border btn-info "
                        >
                          Create Purchase Order
                        </button>
                      </div>

                      <div className="d-flex ">
                        <div className="col-12 ">
                          <Purchase tableData={Details?.eventList?.orderList} />
                        </div>
                      </div>
                    </div>
                  </div>


                  {/* quatation  */}

                  <div className="col-12 d-flex justify-content-center">
                    <div className="bg-white col-12 mt-3">
                      <div className="d-flex justify-content-right">
                        <div className="bg-info col-12 m-1 mt-3 rounded shadow-sm elevation-2 pt-1"></div>
                      </div>

                      <div
                        className="d-flex justify-content-between"
                        style={{
                          paddingBottom: 2,
                          paddingTop: 10,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <label
                          className="ml-6 pt-2 m-0"
                          style={{ fontWeight: "700" }}
                        >
                          Quotation
                        </label>
                        <button
                          type="button"
                          onClick={() => {
                            navigate("/create-quotation", {
                              state: { vendorId: Details?.vendor?.id, vendor: Details?.vendor },
                            });
                          }}
                          className="btn btn-sm border btn-info"
                        >
                          Create Quotation
                        </button>
                      </div>

                      <div className="d-flex ">
                        <div className="col-12 ">
                          <Quotation
                            tableData={Details?.eventList?.quotationList || []}
                            onCreateClick={() => {
                              navigate("/create-quotation", {
                                state: { vendorId: Details?.vendor?.id, vendor: Details?.vendor },
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Status History */}

                  <div className="col-12 d-flex justify-content-center">
                    <div className="bg-white col-12 mt-3">
                      <div className="d-flex ">
                        <div className="bg-warning col-12 m-1 mt-3 rounded shadow-sm elevation-2 pt-1"></div>
                      </div>

                      <label
                        className="ml-6 pt-2  m-0"
                        style={{ "font-weight": "700" }}
                      >
                        Status History
                      </label>

                      <div className="d-flex ">
                        <div className="col-12 ">
                          {/* <div className="col-12 d-flex m-2 mb-3">
                          <div className="col-4 d-flex justify-content-start">
                            <label
                              htmlFor=""
                              className="m-0 p-0"
                              style={{ fontSize: 15 }}
                            >
                              <simple>Show</simple>
                            </label>

                            <div className="col-5">
                              <Field
                                as="select"
                                name="status"
                                id="status"
                                className="border w-100 pl-2"
                              >
                                <option value="number">10</option>
                                {options2.map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </Field>
                              {formik.touched.status &&
                                formik.errors.status && (
                                  <span style={{ color: "red" }}>
                                    {formik.errors.status}
                                  </span>
                                )}
                            </div>

                            <div className="col-4 d-flex justify-content-start">
                              <label
                                htmlFor=""
                                className="m-0 p-0"
                                style={{ fontSize: 15 }}
                              >
                                <simple>entries</simple>
                              </label>
                            </div>
                          </div>
                        </div> */}
                          <Status leadId={vendorId} type="vendor" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
          )}
        </Formik>
        <UserFooter />
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </div>
    </>
  );
};

export default VendorDetailsTables;